import React, { useEffect, useState } from "react";
import apiClient from "../../utils/apiclient";

const Index = () => {
  const isAdmin = localStorage.getItem("bentoAdminDetails") == 4 ? true : false;
  const [data, setData] = useState([]);
  const [editRow, setEditRow] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [newContainerData, setnewContainerData] = useState({});
  const [newContainer,SetnewConatiner]= useState(false);
  useEffect(() => {
    const fetchdata = async () => {
      try {
        const response = await apiClient.get("/coupon");
        console.log(response.data);
        setData(response.data);
      } catch (e) {
        console.log(e);
      }
    };
    fetchdata();
  }, []);

  const handleEditClick = (row) => {
    setEditRow(row.id);
    setEditedData({ ...row });
  };

  const handleChange = (e, field) => {
    setEditedData({ ...editedData, [field]: e.target.value });
  };
   const handlenewChange = (e, field) => {
    setnewContainerData({ ...newContainerData, [field]: e.target.value });
  };

  const parseUserIds = (value) => {
    if (value == null || value === "") return [];
    const rawIds = Array.isArray(value)
      ? value.map((id) => (typeof id === "string" ? id.trim() : id))
      : String(value).split(",").map((id) => id.trim());
    return rawIds
      .filter(Boolean)
      .map(Number)
      .filter((id) => !Number.isNaN(id));
  };

  const handleSave = async () => {
    try {
      const payload = {
        name: editedData.name,
        isvalid:
          editedData.isvalid === true || editedData.isvalid === "true",
        includeInDropdown:
          editedData.includeInDropdown === true ||
          editedData.includeindropdown === true ||
          editedData.includeInDropdown === "true" ||
          editedData.includeindropdown === "true",
        maximumDiscount: Number(editedData.maximumDiscount),
        minimumOrderValue: Number(editedData.minimumOrderValue),
        discountPercentage: Number(editedData.discountPercentage),
        repeatable:
          editedData.repeatable === true || editedData.repeatable === "true",
        limitedUserCoupon:
          editedData.limitedUserCoupon === true ||
          editedData.limitedUserCoupon === "true",
        userId: parseUserIds(editedData.userId),
      };
      const response = await apiClient.put(
        `/coupon/${editedData.id}`,
        payload
      );
      console.log(response.data);
    } catch (e) {
      console.log(e);
    }
    const updatedData = data.map((item) =>
      item.id === editedData.id ? editedData : item
    );
    setData(updatedData);
    setEditRow(null);
  };
  const handleAdd = async () => {
    try {
      const payload = {
        name: newContainerData.name,
        maximumDiscount: Number(newContainerData.maximumDiscount),
        minimumOrderValue: Number(newContainerData.minimumOrderValue),
        discountPercentage: Number(newContainerData.discountPercentage),
        isvalid: newContainerData.isvalid === true || newContainerData.isvalid === "true",
        includeInDropdown:
          newContainerData.includeInDropdown === true ||
          newContainerData.includeInDropdown === "true",
        repeatable:
          newContainerData.repeatable === true ||
          newContainerData.repeatable === "true",
        limitedUserCoupon:
          newContainerData.limitedUserCoupon === true ||
          newContainerData.limitedUserCoupon === "true",
        userId: parseUserIds(newContainerData.userId),
      };
      const response = await apiClient.post("/coupon/add", payload);
      console.log(response.data);
      const updatedResponse = await apiClient.get("/coupon");
      setData(updatedResponse.data);
    } catch (e) {
      console.log(e);
      alert(e.response?.data?.message || "Failed to add coupon");
    }
    console.log(newContainerData);
  };

  return (
    <div className="w-full flex-1 flex flex-col min-h-0 mt-4">
      <div className="flex justify-between items-center mb-2 flex-shrink-0">
        <h2 className="text-xl font-bold text-gray-800">Add Coupon</h2>
      </div>

      <div className="w-full flex-1 overflow-auto pb-4 relative">
        <table className="min-w-max w-full bg-white shadow-md border-collapse">
          <thead className="bg-gray-800 text-white sticky top-0 z-20 shadow-md">
            <tr>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Id</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Name</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">isvalid</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">isIsvalid</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">includeInDropdown</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">repeatable</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">limitedUserCoupon</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">userId</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">maximumDiscount</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">minimumOrderValue</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">discountPercentage</th>
              {(isAdmin) && (
                <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Edit</th>
              )}
            </tr>
          </thead>
        <tbody>
          {data.map((row, index) => (
            <tr
              key={index}
              className="border-b border-gray-300 hover:bg-gray-50"
            >
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">{row.id}</td>

              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">
                {editRow === row.id ? (
                  <input
                    type="text"
                    value={editedData.name || ""}
                    onChange={(e) => handleChange(e, "name")}
                    className="border px-2 py-1 rounded"
                  />
                ) : (
                  row.name
                )}
              </td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">
                {editRow === row.id ? (
                  <input
                    type="checkbox"
                    checked={editedData.isvalid === true || editedData.isvalid === "true"}
                    onChange={(e) =>
                      setEditedData({
                        ...editedData,
                        isvalid: e.target.checked,
                      })
                    }
                  />
                ) : row.isvalid ? (
                  "Yes"
                ) : (
                  "No"
                )}
              </td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">
                {editRow === row.id ? (
                  <input
                    type="checkbox"
                    checked={editedData.isIsvalid === true || editedData.isIsvalid === "true"}
                    onChange={(e) =>
                      setEditedData({
                        ...editedData,
                        isIsvalid: e.target.checked,
                      })
                    }
                  />
                ) : row.isIsvalid ? (
                  "Yes"
                ) : (
                  "No"
                )}
              </td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">
                {editRow === row.id ? (
                  <input
                    type="checkbox"
                    checked={
                      editedData.includeInDropdown === true ||
                      editedData.includeInDropdown === "true" ||
                      editedData.includeindropdown === true ||
                      editedData.includeindropdown === "true"
                    }
                    onChange={(e) =>
                      setEditedData({
                        ...editedData,
                        includeInDropdown: e.target.checked,
                        includeindropdown: e.target.checked,
                      })
                    }
                  />
                ) : row.includeInDropdown || row.includeindropdown ? (
                  "Yes"
                ) : (
                  "No"
                )}
              </td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">
                {editRow === row.id ? (
                  <input
                    type="checkbox"
                    checked={editedData.repeatable === true || editedData.repeatable === "true"}
                    onChange={(e) =>
                      setEditedData({
                        ...editedData,
                        repeatable: e.target.checked,
                      })
                    }
                  />
                ) : row.repeatable ? (
                  "Yes"
                ) : (
                  "No"
                )}
              </td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">
                {editRow === row.id ? (
                  <input
                    type="checkbox"
                    checked={editedData.limitedUserCoupon === true || editedData.limitedUserCoupon === "true"}
                    onChange={(e) =>
                      setEditedData({
                        ...editedData,
                        limitedUserCoupon: e.target.checked,
                      })
                    }
                  />
                ) : row.limitedUserCoupon ? (
                  "Yes"
                ) : (
                  "No"
                )}
              </td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">
                {editRow === row.id ? (
                  <input
                    type="text"
                    value={editedData.userId || ""}
                    onChange={(e) =>
                      setEditedData({
                        ...editedData,
                        userId: e.target.value,
                      })
                    }
                    placeholder="User IDs"
                    className="border px-2 py-1 rounded"
                  />
                ) : row.userId && row.userId.length > 0 ? (
                  String(row.userId).replace(/,/g, ", ")
                ) : (
                  "No user IDs"
                )}
              </td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">
                {editRow === row.id ? (
                  <input
                    type="text"
                    value={editedData.maximumDiscount || ""}
                    onChange={(e) => handleChange(e, "maximumDiscount")}
                    className="border px-2 py-1 rounded"
                  />
                ) : (
                  row.maximumDiscount
                )}
              </td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">
                {editRow === row.id ? (
                  <input
                    type="text"
                    value={editedData.minimumOrderValue || ""}
                    onChange={(e) => handleChange(e, "minimumOrderValue")}
                    className="border px-2 py-1 rounded"
                  />
                ) : (
                  row.minimumOrderValue
                )}
              </td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">
                {editRow === row.id ? (
                  <input
                    type="text"
                    value={editedData.discountPercentage || ""}
                    onChange={(e) => handleChange(e, "discountPercentage")}
                    className="border px-2 py-1 rounded"
                  />
                ) : (
                  row.discountPercentage
                )}
              </td>

              
                        {(isAdmin) && (      
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm">
                {editRow === row.id ? (
                  <button
                    onClick={handleSave}
                    className="bg-green-500 text-white px-3 py-1 rounded"
                  >
                    Save
                  </button>
                ) : (
                  <button
                    onClick={() => handleEditClick(row)}
                    className="bg-blue-500 text-white px-3 py-1 rounded"
                  >
                    Edit
                  </button>
                )}
              </td>
          )}
            </tr>
          ))}
        </tbody>
        </table>
      </div>
  {(isAdmin) && (
    <div className="flex-shrink-0 mt-4 mb-4 border-t pt-4">
      <button className="bg-blue-500 hover:bg-blue-600 transition text-white px-4 py-2 rounded font-medium"
                  onClick={()=>SetnewConatiner(!newContainer)}>
                    Add new Coupon
                  </button>
                  {newContainer? <div className="mt-4 flex flex-wrap items-center gap-2">

  <input
    type="text"
    placeholder="Coupon name"
    className="border-2 border-indigo-600 text-center mr-2"
    onChange={(e) => handlenewChange(e, "name")}
  />

  <input
    type="number"
    placeholder="maximumDiscount"
    className="border-2 border-indigo-600 text-center"
    onChange={(e) => handlenewChange(e, "maximumDiscount")}
  />

  <input
    type="number"
    placeholder="minimumOrderValue"
    className="border-2 border-indigo-600 text-center"
    onChange={(e) => handlenewChange(e, "minimumOrderValue")}
  />

  <input
    type="number"
    placeholder="discountPercentage"
    className="border-2 border-indigo-600 text-center"
    onChange={(e) => handlenewChange(e, "discountPercentage")}
  />

  <input
    type="text"
    placeholder="User IDs (comma separated)"
    className="border-2 border-indigo-600 text-center"
    onChange={(e) => handlenewChange(e, "userId")}
  />

  {/* isvalid checkbox */}
  <label>
    <input
      type="checkbox"
      onChange={(e) =>
        setnewContainerData({
          ...newContainerData,
          isvalid: e.target.checked,
        })
      }
    />
    <span className="ml-1">Is Valid</span>
  </label>

  {/* includeInDropdown checkbox */}
  <label>
    <input
      type="checkbox"
      onChange={(e) =>
        setnewContainerData({
          ...newContainerData,
          includeInDropdown: e.target.checked,
        })
      }
    />
    <span className="ml-1">Include In Dropdown</span>
  </label>

  <label>
    <input
      type="checkbox"
      onChange={(e) =>
        setnewContainerData({
          ...newContainerData,
          repeatable: e.target.checked,
        })
      }
    />
    <span className="ml-1">Repeatable</span>
  </label>

  <label>
    <input
      type="checkbox"
      onChange={(e) =>
        setnewContainerData({
          ...newContainerData,
          limitedUserCoupon: e.target.checked,
        })
      }
    />
    <span className="ml-1">Limited User Coupon</span>
  </label>

  <button
    className="bg-blue-500 text-white px-3 py-1 ml-2 rounded"
    onClick={handleAdd}
  >
    Add
  </button>

</div>:""}</div>)}
    </div>
  );
};

export default Index;
